import Inbox from './ui/inbox';

export default Inbox;
